var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"sear-wrap"},[_c('IndustryCostData'),_c('WeiShouFuWuFei'),_c('BaiDucompanySearch'),_c('HSHExpirationTimeQuery'),_c('ACGExpirationTimeQuery'),_c('IndustryCaseQuery')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }